$(function() {
  OT.Events.on('results:before-render', function(){
    if(OT.Search.Data.get().Display.SuppressScrollToTop) {
      return;
    }
    $('html, body').animate({
      scrollTop: 0
    });
  });
});